import React, { Component } from 'react';

class Header extends Component {
	render() {
		const { title, children, url, image } = this.props;
		var src;

		if (image === undefined) {
			return null
		}

		if (url === undefined) {
			src = image
		} else {
			src = `/articles/${url}/${image}`
		}

		const  container_style= {
			backgroundImage: `url(${src})`
		};

		return (
			<div className='header container' style={container_style}>
				<div className='container header-container' >
					{children}
				</div>
			</div>
		)
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js